export default "__VITE_ASSET__Bp$jAT3f__"